import { Injectable, Type, ViewContainerRef } from '@angular/core';
import { MenuComponent } from 'src/app/components/main/menu/menu.component';

@Injectable({
  providedIn: 'root'
})
export class ComponentWindowManagerService {
  private container: ViewContainerRef;

  public constructor() {
    this.container = MenuComponent.getInstance().menuContainer;
  }

  public createComponent(component: Type<unknown>, params: object): void {
    const instanciaComponente = this.container.createComponent(component);
    /*
      FixMe: no tendriamos que pasarle la instancia del componente padre,
      de momento se hace porque no hay una forma de que un componente se autodestruya,
      cuando creemos nuestro window manager se corregira
    */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (instanciaComponente.instance as any).init(instanciaComponente, params);
  }
}
